<div
    class="ui attached stackable {{ responsiveStepsClass }} steps"
    [ngClass]="{ top: !isBottomPosition, bottom: isBottomPosition }"
>
    <!-- TODO: Add classes for active state -->
    <ng-container *ngFor="let step of steps; index as i">
        <div
            [ngClass]="{
                step: true,
                active: step.id === currentStep,
                done: step.id < currentStep,
                disabled: step.id > currentStep,
                bottom: isBottomPosition
            }"
        >
            <i class="ui icon {{ step.icon }}"></i>
            <div class="content">
                <div class="name">
                    {{ step.title }}
                    <span *ngIf="stepToDisplayMetaData === step.title && metaDataDisplay">{{ metaDataDisplay }}</span>
                </div>
            </div>
        </div>
    </ng-container>
</div>
